<template>
  <div class="overview-wrapper">
    <div class="side-wrapper">
      <ul class="list-group list-group-flush">
        <a
          v-for="(col, i) in searchOptions"
          :key="i"
          href="#"
          class="list-group-item list-group-item-action flex-column align-items-start side-item"
          @click="sideColClicked(i)"
        >
          {{ col.name }}
        </a>
      </ul>
    </div>
    <div class="content-wrapper">
      <b-breadcrumb :items="crumb_links"></b-breadcrumb>
      <dl class="results">
        <p>
          This section of TAIR's website contains links to documents to help you
          maximally use TAIR's database and tools.
        </p>
        <p>
          Use the Definitions help. Wherever you see a
          <b-icon class="ml-2" icon="question-circle-fill"></b-icon> symbol next
          to a word , click on the symbol to see a definition for the word or
          phrase.
        </p>
        <p>
          If you have a specific topic you need help with, you can search ONLY
          within the help section of TAIR using the search box below.
        </p>

        <div class="options-panel">
          <div
            v-for="(option, i) in searchOptions"
            :key="i"
            class="search-option"
          >
            <h3 class="pg-link" @click="sideColClicked(i)">
              {{ option.name }}
            </h3>
            <p>{{ option.description }}</p>
          </div>
        </div>
        <div class="flex text-left mt-2">
          <dt>Configuring your browser to use TAIR.</dt>
          <dd>
            TAIR works best in a current version of a modern web browser such as
            Chrome, Firefox, Safari, or Edge. Most browsers have JavaScript and
            cookies enabled by default. If parts of the site do not display or
            function correctly, please make sure that JavaScript and cookies are
            enabled in your browser settings, and consider updating to the
            latest version of your browser.
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpOverview",
  data() {
    return {
      crumb_links: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Help",
          active: true,
        },
      ],
      overviewTitle: "HELP",
      description:
        "This section of TAIR's website contains links to documents to help you maximally use TAIR's database and tools.",
      searchOptions: [
        {
          name: "YouTube Tutorials",
          route: "https://www.youtube.com/channel/UCqYlBTnoVz6s1beB058lBqQ",
          description: "TAIR's You Tube Channel with video tutorials",
        },
        {
          name: "FAQ",
          route: "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216127/FAQ",
          description:
            "A list of frequently asked questions ordered by major topic.",
        },
        {
          name: "Quick Start",
          route:
            "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216979/Quick+Start",
          description: "A brief introduction to common uses of TAIR.",
        },
        {
          name: "Database and Tool Help Pages",
          route: `https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/42216095/TAIR+Database+and+Tool+Help`,
          description:
            "Help pages for searching TAIR database and using the analysis tools.",
        },
        {
          name: "TAIR Glossary",
          route:
            "https://phoenixbioinformatics.atlassian.net/wiki/spaces/COM/pages/1097072646/TAIR+Glossary",
          description: "A glossary of terms used in TAIR database.",
        },
      ],
    };
  },
  mounted() {
    document.title = "TAIR Help";
  },
  methods: {
    sideColClicked(index) {
      window.open(this.searchOptions[index].route, "_blank");
    },
  },
};
</script>

<style scoped lang="scss"></style>
